import Overlay from "../../Componentes/Overlay";
import SideMenu from "../../Componentes/SideMenu";
import SideMenuBtn from "../../Componentes/SideMenuBtn";

export default function SidebarLicencasColaboradores({
  onClose,
  onLancarLicenca,
  onNovoFornecedor,
  onNovoTipoLicenca,
}) {
  return (
    <Overlay state={true} changeContent={onClose}>
      <SideMenu>
        <SideMenuBtn button="LANÇAR LICENÇA" clickFunc={onLancarLicenca} />
        <SideMenuBtn button="NOVO FORNECEDOR" clickFunc={onNovoFornecedor} />
        <SideMenuBtn button="NOVO TIPO DE LICENÇA" clickFunc={onNovoTipoLicenca} />
      </SideMenu>
    </Overlay>
  );
}
